var FontSizes;
(function (FontSizes) {
    FontSizes["Default"] = "1.0rem";
    FontSizes["Small"] = "1.2rem";
    FontSizes["Regular"] = "1.4rem";
    FontSizes["Big"] = "1.6rem";
})(FontSizes || (FontSizes = {}));
export default FontSizes;
//# sourceMappingURL=fontSizes.js.map